import PageHeader from 'components/organisms/PageOutlines/PageHeader';
import PageWrapper from 'components/organisms/PageOutlines/PageWrapper';
import { Spinner } from 'components/widgets';
import { Formik } from 'formik-2';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { withLocalize } from 'react-localize-redux';
import toaster from '../utils/toaster';
import PartnerInformationForm from './components/PartnerInformationForm';
import css from './page.css';
import service from './service';

const translationPrefix = 'STATIC.PAGES.PARTNER_INFORMATION';

const INITIAL_PROFILE = {
    companyName: '',
    website: '',
    description: '',
    categories: [],
    logoUrl: '',
    logoFile: null,
};

const hasRequiredPartnerFields = ({ website, hasLogo }) => Boolean((website || '').trim()) && Boolean(hasLogo);

const PartnerInformation = ({ translate }) => {
    const [savedProfile, setSavedProfile] = useState(INITIAL_PROFILE);
    const [isLoading, setIsLoading] = useState(true);
    const shouldRedirectAfterFirstSaveRef = useRef(false);

    useEffect(() => {
        service
            .getPartnerProfile()
            .then(data => {
                const profileData = {
                    companyName: data.company_name || '',
                    website: data.website || '',
                    description: data.description || '',
                    categories: data.categories || [],
                    logoUrl: data.logo_url || '',
                    logoFile: null,
                };
                const isInitiallyValid = hasRequiredPartnerFields({
                    website: profileData.website,
                    hasLogo: Boolean(profileData.logoUrl.trim()),
                });
                shouldRedirectAfterFirstSaveRef.current = !isInitiallyValid;
                setSavedProfile(profileData);
            })
            .catch(() => toaster.error(translate(`${translationPrefix}.MESSAGES.LOAD_ERROR`)))
            .finally(() => setIsLoading(false));
    }, [translate]);

    return (
        <PageWrapper className={css.wrapper} disablePadding>
            <PageHeader
                text={`${translationPrefix}.PAGE_TITLE`}
                subText={{
                    subTitle: `${translationPrefix}.PAGE_SUBTITLE`,
                }}
                shouldAddPadding
                className={css.pageHeader}
            />
            {isLoading ? (
                <Spinner expanded show />
            ) : (
                <Formik initialValues={savedProfile} enableReinitialize>
                    <PartnerInformationForm
                        translate={translate}
                        setSavedProfile={setSavedProfile}
                        shouldRedirectAfterFirstSaveRef={shouldRedirectAfterFirstSaveRef}
                    />
                </Formik>
            )}
        </PageWrapper>
    );
};

PartnerInformation.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default withLocalize(PartnerInformation);
